module.exports = __webpack_public_path__ + "static/light_left-5f3c7ee0f7ce413500f908bc0c31c38c.png";